<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <div v-if="p_idAtencion != 0">
              <router-link to="/atencion">Atenciones</router-link> >
              <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link>
              > Alergias
            </div>
            <div v-else>
              <router-link to="/persona">Personas</router-link> >
              <router-link :to="'/personaform/' + p_idPersona">{{ datoPersona.nombreCompleto }}</router-link>
              > Alergias
            </div>
          </div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de alergias"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>
<Modal v-model:modelValue="showModalHelp" title="Ayuda — Alergias del Paciente">
  <AyudaAlergiaPers />
</Modal>
    <hr>

    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-7">
                  <label class="form-label">Nombre</label>
                  <input type="text" class="form-control" v-model="datoPersona.nombreCompleto" disabled>
                </div>
                <div class="col-2">
                  <label class="form-label">{{ datoPersona.tipoIdenNombre }}</label>
                  <input type="text" class="form-control" v-model="datoPersona.documento" disabled>
                </div>
                <div class="col-3 d-flex align-items-end justify-content-end">
                  <button @click.prevent="mostrarOcultarBloque">
                    {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Email</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="datoPersona.email" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Estado Civil</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.estadoCivilNombre" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Localidad</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="datoPersona.localidadNombre" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha de Nacimiento</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" :value="getFormattedDate(datoPersona.fechaNac)" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Sexo</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" :value="sexoDecodificado" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label class="form-label">Dirección</label>
                    <input type="text" class="form-control" v-model="datoPersona.direccion" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">IdPersona</label>
                    <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">IdEmpresa</label>
                    <input type="text" class="form-control" v-model="datoPersona.idEmpresa" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">IdUsuarioReg</label>
                    <input type="text" class="form-control" v-model="datoPersona.idUsuarioReg" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">FechaReg</label>
                    <input type="text" class="form-control" :value="getFormattedDate(datoPersona.fechaReg)" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">IdUsuarioAct</label>
                    <input type="text" class="form-control" v-model="datoPersona.idUsuarioAct" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">FechaAct</label>
                    <input type="text" class="form-control" v-model="datoPersona.fechaAct" disabled>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

    <!--  DataTable de Alergias  -->
    <DataTable
      :data="alergiaperss"
      :columns="columnasAlergia"
      idField="idAlergiaPers"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay alergias registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idAlergiaPers)"
    />

    <!-- Modal Alergia -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label">Alergia</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoAlergiaPers.idAlergia">
                      <option v-for="a in alergias" :value="a.idAlergia" :key="a.idAlergia">
                        {{ a.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label">Fecha de Diagnóstico</label></div>
                  <div class="col-9">
                    <input type="date" class="form-control" v-model="datoAlergiaPers.fechaDiag" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label">Severidad</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoAlergiaPers.severidad">
                      <option value="Leve">Leve</option>
                      <option value="Moderada">Moderada</option>
                      <option value="Severa">Severa</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label">Observación</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control" v-model="datoAlergiaPers.observacion"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label">Fecha de Registro</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control"
                      :value="getFormattedDate(datoAlergiaPers.fechaReg)" disabled>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-success" @click.prevent="guardarAlergiaPers" v-if="btnCrear_det">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">save</span> Guardar
            </button>
            <button class="btn btn-success" @click.prevent="guardarEditAlergiaPers" v-if="btnEditar_det">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import AyudaAlergiaPers from '@/views/ayuda/AyudaAlergiaPers.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import api from "@/services/api"
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
import swal from 'sweetalert'

export default {
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
    p_idPersona:      { type: Number, required: true },
  },
  components: { Layout, Footer, DataTable, AyudaAlergiaPers },
  data() {
    return {
      // Master
      datoPersona: {},
      mostrarBloque: false,
      showModalHelp: false,
      // Detail
      alergiaperss: [],
      datoAlergiaPers: {},
      titulo: '',
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
      alergias: [],
      // Columnas del DataTable
      columnasAlergia: [
        { field: 'alergiaNombre', label: 'Nombre' },
        { field: 'severidad',     label: 'Severidad' },
        { field: 'observacion',   label: 'Observación' },
        {
          field: 'fechaDiag',
          label: 'Fecha Diagnóstico',
          format: (val) => dateFormat.getFormattedDate(val),
        },
      ],
    }
  },
  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    sexoDecodificado() {
      const s = this.datoPersona.sexo
      if (s === 'M') return 'Masculino'
      if (s === 'F') return 'Femenino'
      return s || ''
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.abrirEditar(this.p_idPersona)
    this.getDataTodos()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque
    },
    //  Master
    abrirEditar(idPersona) {
      if (idPersona) {
        api.get('/vwpersonas/' + idPersona).then(resp => {
          this.datoPersona = resp.data
        })
      }
    },
    //  Detail
    getDataTodos() {
      api.get('/vwalergiaperss/idpersona/' + this.p_idPersona).then(response => {
        this.alergiaperss = response.data.reverse()
      })
    },
    validarFormDet() {
      const requiredFields    = ['idAlergia', 'fechaDiag', 'severidad']
      const requiredFieldsText = ['Alergia', 'Fecha Diagnóstico', 'Severidad']
      return validarForm(this.datoAlergiaPers, requiredFields, requiredFieldsText)
    },
    async guardarAlergiaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        this.datoAlergiaPers.idPersona = this.datoPersona.idPersona
        await api.post('/alergiaperss', this.datoAlergiaPers)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Alergia registrada exitosamente!", "success")
        this.getDataTodos()
      } catch {
        swal("Error!", "Intentelo de nuevo!", "error")
      }
    },
    async guardarEditAlergiaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        await api.post('/alergiaperss', this.datoAlergiaPers)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Alergia actualizada exitosamente!", "success")
        this.getDataTodos()
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error")
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalCrear() {
      this.datoAlergiaPers = {}
      this.titulo          = 'Registrar alergia'
      this.btnCrear_det    = true
      this.btnEditar_det   = false
      this.fetchAlergias()
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },
    abrirModalEditar(idAlergiaPers) {
      this.titulo        = 'Editar alergia'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      this.fetchAlergias()
      if (idAlergiaPers) {
        api.get('/vwalergiaperss/' + idAlergiaPers).then(resp => {
          this.datoAlergiaPers = resp.data
        })
      }
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },
    fetchAlergias() {
      api.get('/alergias').then(r => { this.alergias = r.data })
        .catch(e => console.error('Error fetching alergias:', e))
    },
  },
}
</script>
<style src="@/assets/css/listaRegistros.css" scoped></style>